// eslint-disable-next-line security/detect-unsafe-regex
export const PHONE_REGEX =
    /^(?:$|\d{1,3}|\+?\d{0,4}[-.\s]?\(?\d{1,3}\)?[-.\s]?\(?\d{1,4}\)?[-.\s]?\(?\d{1,4}\)?[-.\s]?\(?\d{1,9}\)?\s?[xX]?\d{0,5})$/;

export const TRAILING_SLASH_REGEX = /\/$/;
